module.exports = __webpack_public_path__ + "static/media/S45_black.06f7afed.png";